const date = new Date();
const year = date.getFullYear();

const APPCONFIG = {

  host: process.env.REACT_APP_BACKEND,
  redirectOnErrorUrl: process.env.REACT_APP_BACKEND,
  appFrontendHostname: process.env.REACT_APP_FRONTEND_HOSTNAME,
  appBackendHostname: process.env.REACT_APP_BACKEND,

  logoutUrl: process.env.REACT_APP_BACKEND + 'logout',
  helpUrl: 'https://besiazure.sharepoint.com/sites/Global_IT/Shared%20Documents/Applications/WebApps/Employee%20Self-Service%20Portal?csf=1&web=1&e=octkYf',
  applicationLinks: [
    {
      id: 1,
      url: 'https://timeabsencemanagement.besi.com/',
      name: 'Time Absence Management',
      icon: 'access_time',
      target: "_blank",
      allowLocation: ['AT11', 'CH10']
    },
    {
      id: 2,
      url: 'https://eu1.concursolutions.com/',
      name: 'Travel & Expense (Concur)',
      icon: 'flight_takeoff',
      target: "_blank",
      allowLocation: ['AT11']
    },
    {
      id: 3,
      url: 'notes:///C1256C620035CD6F/fsMain?OpenFrameset&view=D44F8A24BCB19D9DC1256C620035CD74',
      name: 'Travel Accounting',
      icon: 'contacts',
      target: "_self",
      allowLocation: ['AT11']
    },
    {
      id: 4,
      url: 'https://educationrequest.besi.com',
      name: 'Education Request',
      icon: 'school',
      target: "_blank",
      allowLocation: ['AT11', 'CH10', 'SG30']
    }
  ],

  payslipLocation: ['AT11', 'CH10'],

  travelExpenseLocation: ['AT11'],

  policiesLink: [
    {
      id: 3,
      url: 'https://besiazure.sharepoint.com/sites/BesiAustriaGmbH-SITE/Shared%20Documents/General/Besi%20AT%20Policies%20and%20Guidelines/Flexitime%20Agreement/BV_Gleitzeit_September%202010_final.pdf?csf=1&web=1&e=NzCQgI',
      name: 'Gleitzeitvereinbarung (DE)',
      icon: 'link',
      target: "_blank",
      allowLocation: ['AT11']
    },
    {
      id: 4,
      url: 'https://besiazure.sharepoint.com/sites/BesiAustriaGmbH-SITE/Shared%20Documents/General/Besi%20AT%20Policies%20and%20Guidelines/Flexitime%20Agreement/BV_Gleitzeit_September%202010_english.pdf?csf=1&web=1&e=ckeJYf',
      name: 'Gleitzeitvereinbarung (EN)',
      icon: 'link',
      target: "_blank",
      allowLocation: ['AT11']
    }
  ],

  permissionDeniedUrl: '#/user/notallowed',
  /* used on fake auth*/
  permissionDeniedPathName: '/user/notallowed',


  brand: 'BESI Employee Self-Service Portal',
  brandHeaderName: 'Employee Self-Service Portal',
  user: 'Lisa',
  year,
  AutoCloseMobileNav: true,          // true, false. Automatically close sidenav on route change (Mobile only)
  showCustomizer: false,              // Boolean: true, false. Customizer will be opened (visible) first time app was loaded if set to true
  color: {
    primary: '#00BCD4',
    success: '#8BC34A',
    info: '#66BB6A',
    infoAlt: '#7E57C2',
    warning: '#FFCA28',
    danger: '#F44336',
    text: '#3D4051',
    gray: '#EDF0F1'
  },
  settings: {
    layoutBoxed: false,               // true, false
    navCollapsed: false,              // true, false
    navBehind: true,                 // true, false
    fixedHeader: true,                // true, false
    sidebarWidth: 'middle',           // small, middle, large
    colorOption: '14',                // String: 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    theme: 'light',                   // light, gray, dark
  }
};

export default APPCONFIG;
